
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/checkout/items",
      function () {
        return require("private-next-pages/checkout/items/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/checkout/items"])
      });
    }
  